import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UI_LOADER } from '@maximizer/core/shared/ui/components/loader';
import { TokenMonitorService } from '@maximizer/outlook/shared/data-access';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'maximizer-outlook-session-refresh-notice',
  template: `
    @if (noticeState() !== 'hidden') {
      <div
        class="fixed inset-0 z-50"
        role="alertdialog"
        aria-modal="true"
        [attr.aria-label]="'outlook.auth.session.noticeLabel' | translate"
      >
        <div class="absolute inset-0 bg-white opacity-30"></div>

        @if (noticeState() === 'refreshing') {
          <maximizer-loader type="legacy" />
        }

        <div class="relative z-[60] m-2">
          @switch (noticeState()) {
            @case ('refreshing') {
              <maximizer-outlook-status-message
                [type]="'info'"
                [message]="'outlook.auth.session.refreshing' | translate"
              />
            }
            @case ('continueRequired') {
              <maximizer-outlook-status-message
                [type]="'warning'"
                [message]="'outlook.auth.session.continueMessage' | translate"
                [actionText]="'outlook.buttons.continue' | translate"
                [actionButtonId]="'outlook-auth-session-continue'"
                (action)="continueRefresh()"
              />
            }
            @case ('retryRequired') {
              <maximizer-outlook-status-message
                [type]="'error'"
                [message]="'outlook.auth.session.retryMessage' | translate"
                [actionText]="'outlook.buttons.tryAgain' | translate"
                [actionButtonId]="'outlook-auth-session-retry'"
                (action)="retryRefresh()"
              />
            }
          }
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, OUTLOOK_SHARED_UI, UI_LOADER],
})
export class SessionRefreshNoticeComponent {
  private readonly tokenMonitorService = inject(TokenMonitorService);

  protected readonly noticeState = this.tokenMonitorService.noticeState;

  protected continueRefresh(): void {
    void this.tokenMonitorService.continueRefresh();
  }

  protected retryRefresh(): void {
    void this.tokenMonitorService.retryRefresh();
  }
}
